import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { queryProductVersions, QUERY_KEY } from 'src/queries/queryProductVersions';

type Products = MCP.Products.ProductSearch.Models.ProductVersionsResponse;

export const buildProductVersionQueryKey = (
    accessToken: string | undefined | false,
    search: App.ProductSearch.PagedVersionsSearch,
): App.ProductSearch.ProductVersionsQueryKey => ([QUERY_KEY, accessToken, search]);

export const useQueryProductVersions = (
    accessToken: string | undefined | false,
    search: App.ProductSearch.PagedVersionsSearch,
    options?: UseQueryOptions<Products, Error, Products, App.ProductSearch.ProductVersionsQueryKey>,
): UseQueryResult<Products, Error> => useQuery<Products, Error, Products, App.ProductSearch.ProductVersionsQueryKey>(
    buildProductVersionQueryKey(accessToken, search),
    queryProductVersions,
    {
        suspense: false,
        ...options,
    },
);
